import { Component, OnInit, OnDestroy } from '@angular/core';
import {MeasgrowthService} from '../measgrowth.service';
import { UntypedFormBuilder,FormGroup,FormControl } from '@angular/forms';
import {DopplerService} from '../doppler.service';
import {ExamsService} from '../exams.service';
import { Observable, Subscription } from 'rxjs';
import {AutotextService} from '../autotext.service';

@Component({
    selector: 'app-doppler',
    templateUrl: './doppler.component.html',
    styleUrls: ['./doppler.component.scss'],
    standalone: false
})
export class DopplerComponent implements OnInit,OnDestroy {

  
  fetusSub:Subscription;
  dopSub:Subscription;
  mediaSub: Subscription;
  dopplerLoaded=false;

  constructor(private ms: MeasgrowthService, private fb: UntypedFormBuilder, public dops:DopplerService, public es: ExamsService, public atS: AutotextService) { 
    ms.setGA();
    this.dopSub=this.dops.loaded$.subscribe(()=>{
      this.dopplerLoaded=true;
      this.dopSub.unsubscribe();
    });
   
  }

  ngOnInit() {
    this.dops.loadData();
    this.fetusSub = this.es.fetusChange$.subscribe(()=> {
      this.dops.loadData();
    });
    this.es.getSRs();
    if(!this.es.isClosed)
      this.mediaSub =  this.es.mediaArrived$.subscribe((mediatype)=>{
        if(mediatype == 'html')
          this.dops.loadData();
      });
  }

  ngOnDestroy(): void {
    this.fetusSub.unsubscribe();
    this.dopSub.unsubscribe();
    if(this.mediaSub)
      this.mediaSub.unsubscribe();
  }

}
